module.exports = __webpack_public_path__ + "img/ercode_zbgj.53301681.png";